module.exports = __webpack_public_path__ + "img/bg-mbl-B.4b3bc243.png";